import { Helmet } from "react-helmet";
import NotFoundLayout from "../sections/notFound/not-found-layout";

const NotFound = () => {
    <Helmet>
        <title>Not Found</title>
    </Helmet>

    return(
        <>
            <NotFoundLayout />
        </>
    );
}

export default NotFound;